import '@xyflow/react/dist/style.css';
import './generated/global.css';
import { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { DCHost } from './dc-runtime';
import { Overlays } from './Overlays';
import { LiveController } from './LiveController.js';
import { ResetPassword } from './ResetPassword';
import { Template } from './generated/template';

/** Твики прототипа (data-props). В проде — живой API и реальная авторизация. */
const params = new URLSearchParams(location.search);
export const TWEAKS = {
  role: 'owner',
  aiEnabled: false,
  simulateConflict: false,
  apiMode: params.get('mock') === '1' ? 'mock' : 'live',
  authScreen: 'auto',
  demoData: params.get('demo') === '1',
};

export function LegacyApp() {
  if (location.pathname === '/auth/reset') return <ResetPassword />;
  return <Shell />;
}

const noop = () => () => {};
const zero = () => 0;

function Shell() {
  const host = useRef<DCHost>(null);
  return (
    <>
      <DCHost ref={host} logic={LiveController} template={Template} props={TWEAKS} />
      <OverlaysMount host={host} />
    </>
  );
}

/** Оверлеи подключаются, когда контроллер создан (после монтирования DCHost), и перерисовываются вместе с ним. */
function OverlaysMount({ host }: { host: React.RefObject<DCHost | null> }) {
  const [, force] = useState(0);
  useEffect(() => {
    if (host.current) force(1);
  }, [host]);
  const ctl = host.current?.logic as LiveController | undefined;
  useSyncExternalStore(ctl?.subscribe ?? noop, ctl?.version ?? zero);
  return ctl ? <Overlays ctl={ctl} /> : null;
}
